import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'shc-subscribe-now-modal',
  templateUrl: './subscribe-now-modal.component.html',
  styleUrls: ['./subscribe-now-modal.component.scss'],
})
export class SubscribeNowModalComponent implements OnInit {

  constructor(
    private router: Router,
    private modalCtrl: ModalController
  ) { }

  ngOnInit() { }

  routeToSubscription() {
    this.modalCtrl.dismiss();
    this.router.navigate(['subscriptions']);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
